import { PrinterPosCancelIcon } from './PrinterPosCancelIcon';

/**
 * author: Colton Wiscombe
 * id CF5532E5-1956-430A-A661-A5361A8BEBF1
 * name printer-pos-cancel
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-cancel.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleCancelIcon = PrinterPosCancelIcon;
export default PrinterPointOfSaleCancelIcon